/* Cart drawer upsell — Lissensa Chile
 * Ajoute 2 vraies variantes (vrais SKU) puis applique le code de
 * remise EXTRA2PARES, qui se combine avec la remise Kaching.
 * Délégation sur `document` : le bloc est re-rendu par la Section
 * Rendering API, donc rien à rebrancher après chaque modif du panier.
 */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false;

  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function innerHTMLFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function applySections(sections) {
    if (sections['cart-drawer']) {
      var inner = document.querySelector('#CartDrawer .drawer__inner');
      var html = innerHTMLFrom(sections['cart-drawer'], '.drawer__inner');
      if (inner && html !== null) {
        inner.innerHTML = html;
        inner.classList.remove('is-empty');
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleHtml =
        innerHTMLFrom(sections['cart-icon-bubble'], '.shopify-section') ||
        innerHTMLFrom(sections['cart-icon-bubble'], '#cart-icon-bubble');
      if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'liss-upsell' });
    }
  }

  /* Lit les 2 sélections et les regroupe par variante
     (si les 2 paires sont identiques -> une ligne quantité 2). */
  function collectItems(box) {
    var map;
    try {
      map = JSON.parse(box.querySelector('[data-liss-variants]').textContent);
    } catch (e) {
      return { error: 'variant_map' };
    }

    var counts = {};
    var picks = box.querySelectorAll('[data-liss-pick]');

    for (var i = 0; i < picks.length; i++) {
      var talla = picks[i].querySelector('[data-liss-talla]').value;
      var color = picks[i].querySelector('[data-liss-color]').value;
      var id = map[talla + '|' + color];
      if (!id) return { error: 'unavailable', talla: talla, color: color };
      counts[id] = (counts[id] || 0) + 1;
    }

    return {
      items: Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      })
    };
  }

  function showError(box, message) {
    var el = box.querySelector('[data-liss-upsell-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-liss-upsell-add]');
    if (!btn) return;

    event.preventDefault();
    if (busy || btn.disabled) return;

    var box = btn.closest('[data-liss-upsell]');
    if (!box) return;

    var picked = collectItems(box);

    if (picked.error === 'unavailable') {
      showError(box, 'Talla ' + picked.talla + ' en ' + picked.color + ' no está disponible.');
      return;
    }
    if (picked.error) {
      showError(box, 'No pudimos agregarlo. Intenta de nuevo.');
      return;
    }

    var errEl = box.querySelector('[data-liss-upsell-error]');
    if (errEl) errEl.hidden = true;

    busy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');

    // La remise (−14.990 dès 4 unités) est AUTOMATIQUE côté Shopify et
    // se combine avec celle de Kaching : rien à appliquer ici, elle est
    // déjà dans les totaux que renvoie la Section Rendering API.
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: picked.items, sections: SECTIONS })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'cart_error');
          return data;
        });
      })
      .then(function (data) {
        if (data.sections) applySections(data.sections);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        showError(
          box,
          err && err.message && err.message !== 'cart_error'
            ? err.message
            : 'No pudimos agregarlo. Intenta de nuevo.'
        );
      })
      .finally(function () {
        busy = false;
      });
  });
})();
